import React from 'react';
import { Route } from 'react-router-dom';
import Link from 'gatsby-link';
import cn from 'classnames';
import './Navbar.styl';
import Toggle from 'react-toggled';
import Cookies from 'js-cookie';

class Navbar extends React.Component {
  renderLogin = () => {
    let sessionCookie = Cookies.get('ATIWBESESSION');
    if (sessionCookie) {
      return (
        <a href="/wbe" className="c-navbar__login-btn t-link">
          <span className="min-tabletLg" style={{ marginRight: 7, textTransform: "initial" }}>
            ATI Connect
          </span>
        </a>
      );
    } else {
      return (
        <Link to="/login" className="c-navbar__login-btn t-link">
          <span className="min-tabletLg" style={{ marginRight: 7 }}>
            Login
          </span>
          <svg
            viewBox="0 0 30.595 12.238"
            width="24"
            height="24"
            fill="currentColor"
          >
            <g transform="translate(-5 -22)">
              <path
                d="M-822,1194.358a6.119,6.119,0,0,1,6.119-6.119,6.12,6.12,0,0,1,5.564,3.569h16.362l2.55,2.55-2.55,2.55h-1.53l-1.53-1.02-1.529,1.02h-1.53l-1.53-1.02-1.53,1.02h-1.02l-1.53-1.02-1.529,1.02h-3.1a6.12,6.12,0,0,1-5.564,3.569A6.119,6.119,0,0,1-822,1194.358Zm2.55,0a1.53,1.53,0,0,0,1.529,1.53,1.53,1.53,0,0,0,1.53-1.53,1.53,1.53,0,0,0-1.53-1.53A1.53,1.53,0,0,0-819.45,1194.358Z"
                transform="translate(827 -1165.238)"
              />
            </g>
          </svg>
        </Link>
      );
    }
  }

  render() {
    return <Route
      render={({ location }) => {
        const isHomePage =
          location.pathname === '/' || location.pathname === '/ati/'

        return (
          <Toggle>
            {({ on, getTogglerProps, setOff }) => (
              <nav
                className={cn('c-navbar', {
                  't-context--dark': isHomePage,
                  't-context--light': !isHomePage,
                  'c-navbar--light': !isHomePage,
                })}
              >
                <button
                  className={cn('c-navbar__nav-btn', { 'is-open': on })}
                  {...getTogglerProps()}
                />
                <Link
                  to="/"
                  className="c-navbar__logo t-link"
                  activeClassName="active"
                >
                  <svg viewBox="0 0 193.2 48.2" width={140} height={35}>
                    <path
                      fill="#00304D"
                      d="M50 31.7c0 .4-.4.8-.8.8h-1.7c-1.4-.2-3.1-1-3.1-3v-3.3c0-.4.4-.8.8-.8h3.9c.5 0 .8.4.8.8v5.5h.1zm12.3-19.3c1.2-1.3 1.8-3 1.9-4.8a8 8 0 0 0-16.1 0 8 8 0 0 0 1.1 4h-5.4v-10C43.8 1 42.5.5 41 .5h-7.1c-1.6 0-2.8.5-2.8 1.1v19.7A16.6 16.6 0 1 0 21.9 45c.2.5.6.9 1.1.9h38.2c.5 0 .9-.7.9-1.6V12.4h.2z"
                    />
                    <path
                      fill="#FFF"
                      d="M58.7 43.9h-5.3c-.7 0-1.3-.9-1.3-2.1V17.4c0-1.1.4-2.1 1.3-2.1a7 7 0 0 0 5.3 0c.7 0 1.3.9 1.3 2.1v24.3c-.1 1.3-.6 2.2-1.3 2.2m0 0h-5.3c-.7 0-1.3-.9-1.3-2.1V17.4c0-1.1.4-2.1 1.3-2.1a7 7 0 0 0 5.3 0c.7 0 1.3.9 1.3 2.1v24.3c-.1 1.3-.6 2.2-1.3 2.2zm-9.1-9.2c-4.8.5-7.3-1.9-7.3-4.6V23h7c.3 0 .6-.6.6-1.4v-6.2c0-.7-.3-1.4-.6-1.4h-7V3.4c0-.6-.9-1-2-1h-5.1c-1.1 0-2 .5-2 1V30c0 14.1 14 14.7 16.5 14.4.2 0 .4 0 .4-.6 0-5 .3-8.3-.5-9.1m0 0c-4.8.5-7.3-1.9-7.3-4.6V23h7c.3 0 .6-.6.6-1.4v-6.2c0-.7-.3-1.4-.6-1.4h-7V3.4c0-.6-.9-1-2-1h-5.1c-1.1 0-2 .5-2 1V30c0 14.1 14 14.7 16.5 14.4.2 0 .4 0 .4-.6 0-5 .3-8.3-.5-9.1zm6.7-32.5a5.6 5.6 0 0 0-5.6 5.5 5.6 5.6 0 0 0 5.7 5.5c3-.1 5.5-2.5 5.5-5.5 0-3.1-2.5-5.5-5.6-5.5m0 0a5.6 5.6 0 0 0-5.6 5.5 5.6 5.6 0 0 0 5.7 5.5c3-.1 5.5-2.5 5.5-5.5 0-3.1-2.5-5.5-5.6-5.5zM31.1 29.3a14.6 14.6 0 1 0-14.7 14.5h.1c2.1 0 4.2-.5 6.1-1.4v.6c0 .5.5.9 1.3.9h6c.7 0 1.3-.4 1.3-.9l-.1-13.7m0 0a14.6 14.6 0 1 0-14.7 14.5h.1c2.1 0 4.2-.5 6.1-1.4v.6c0 .5.5.9 1.3.9h6c.7 0 1.3-.4 1.3-.9l-.1-13.7zm23.3-11.8l-.1.8v21.9c0 .8.2 1.6.5 1.6h2.8c.3 0 .5-.7.5-1.6V18.4l-.1-.8c-.6.2-1.2.2-1.9.2-.5 0-1.1 0-1.7-.3zm-6.6 19.3a7.4 7.4 0 0 1-7.6-7.2v-9.1h6.9c.3 0 .6-.3.6-.6v-2.7c0-.3-.3-.6-.6-.6h-6.9V5c0-.4-.4-.6-.7-.6h-3.2c-.4 0-.7.3-.7.6v23.5c.2 7.3 3.2 12.1 11.9 13.5.4.1.8-.1.8-.5 0-3.6.2-4.1-.5-4.7zm8.5-32.7c-2 0-3.5 1.6-3.5 3.6s1.6 3.6 3.5 3.6c2 0 3.5-1.6 3.5-3.6.1-2-1.5-3.6-3.5-3.6zm.9 40.3v.2h.5v1h.3v-1h.4v-.2h-1.2zm2.4 0l-.3.8-.2-.8h-.4v1.3h.2v-1l.3 1h.3l.3-1v1h.2v-1.3h-.4zM25.5 29.2l.1-.1h.2l-.1.1h-.2zm-.3 2.9l.1-.1-.1.1zm-.1.2l.1-.1-.1.1zm-1.5 5.2l.1-.1-.1.1zm-.5.2l.1-.1-.1.1zm-6.9-1.5h.1l.1-.1-.2.1zm-8.7-4.6v.1-.1zm-.3-.7l.1.1-.1-.1zm17.1-3l-.1-.1.1.1zm-.1.1l-.1.1.1-.1zm-1.6 3.3l-.1.1.1-.1zm-6.8-4.4zm11.7-.3v-.2h-.2v-.1h-.1l-.1-.3-.1-.3-.2-.1v.1h-.3l-.3.1v.7H26v.1l-.6.1-.5.1h-.1l-.1.1-.2.1v.1l-.1.1.1-.1V27l-.1.1h-.1l-.2.1H24l.1.1h-.4l-.4.2-.1.1-.1.5h.3v.3l-.1.1-.1.1-.1.1H23l.1-.1.1-.1.1-.1.1-.1h-.5l-.1.1h-.2l-.1.1v.1H22v-.2h.2V27.8l-.3.2h-.1l-.1.1v.1-.2l.1-.1v-.5h-.1l-.4-.2h-.4v.2-.1l-.1.1v.5l.1.1v.4l-.1.2-.1.1v.1l-.2.4-.1.1h-.1v-.1l-.1-.2v-.6l.1-.1v-.6l.1-.1v-.2l-.1.1v.2l-.1.1v-.2l.1-.2.1-.1h.1v.1l.1-.1h.2v-.1h.4V27H21v-.1h-.9l-.1-.1v-.1l-.1-.1h-.1v-.1l.1-.1h-.2l-.1.1-.1.1h-.1l-.1.1H19l-.1.1h-.2v-.2l-.2.1h-.2v-.1l.2-.2.3-.2h.1l.1-.1h-.7V26h-.5v-.1l-.1-.2v.2h-2.2l-.8-.7-.3-.1H14l-.3-.1-.3-.1-.3-.1-.3-.1h-.2l-.3-.1-.3-.1-.3-.1-.4-.1-.6-.2-.5-.1-.2-.1-.2-.1-.3-.1-.3-.1-.3-.1v.5l-.2.1h-.1V24l.1-.1v-.1h-.1l-.1-.1h-.3l-.1-.1v-.1V24.3v-.1.1l.1.1.1.1-.1-.1h-.1v.2l-.4.5-.1.1-.1.3v.1l-.1.1h-.1l-.1.1v.2l-.1.2v.4l-.1.1-.1.1-.1.4h-.1v1.1l.1.2V28.8v-.1h.1l.1.2h-.1v.1-.2.4H7v.2h-.1v.1l.1.2v.2l.1.1v.4l.1.1.1.3v.2l.1.1v.2h.1l.1.1v.1l.1.1v.5l.9.2 1.4 1 .8.2.3.1v-.2l.7.1.1.1v.1l.1.1v.2l.1.2.2.2.1.4.1.2.1.1.2.2.2.1.2-.3h.5l.1.1.1.1v.1l.1.1.1.4.1.2.1.2.1.1.1.4.1.2.1.1h.1l.1.1h.2l.2.1h.1V36.4h.1v-.1h.2v.1l.1-.1h.2l.1-.1v-.3.1h.1l.2-.1h.4l.2.1h.5l.1.1v.1h.1l.1.1h.6l.1-.1h.2l.1.1h.2v-.1l.5-.8h-.1v-.1l.1-.1v-.1h-.1V35h-.2l-.1-.1v-.1h.5l.1-.1h.4l.1-.2v.2h.2l.1-.1v.1h.5l.2.1v.1h.2l.1-.1h.3l.1.1v.1l.1.1h.2v.6-.1.4l.1.1.1.1v.1h.1l.1.2v.1h.2l.1-.1h.1v-1.2l-.1-.1v-.4l-.2-.2-.1-.3.4.5v-.4l.1-.2V34h.3l.2-.2v-.1h.1V33.4l.1-.1h.1l.1-.1v-.1l.1-.1.1-.1h.1l.1-.1V32.5h-.2v-.2.1h.1v.1-.6h-.2v-.1H24v-.3l.1-.1v-.1V31.6h.2v.5-.2l.1-.2v-.3l.7-1-.1-.2-.1-.2v-.1h.6v.1V29.1h.1l.1-.1h.3l.2-.1.1-.1v-.1.1h.1l.1-.1h.1l.1-.1v-.1.1h-.2v-.2h-.1v-.1l-.1-.1v-.1l.1-.1v-.7h.1v-.1h.1l.8-.4.1-.2z"
                    />
                    <path
                      fill="#E11F32"
                      d="M29.1 29.2a12.2 12.2 0 0 0-12.3-12A12 12 0 0 0 4.6 29a12 12 0 0 0 11.8 12.2h.5a13 13 0 0 0 6.7-1.9v2.5l.1.1h5.2l.1-.1v-11l.1-1.6m25.3-11.7l-.1.8v21.9c0 .8.2 1.6.5 1.6h2.8c.3 0 .5-.7.5-1.6V18.4l-.1-.8c-.6.2-1.2.2-1.9.2-.5 0-1.1 0-1.7-.3m-6.6 19.3a7.4 7.4 0 0 1-7.6-7.2v-9.1h6.9c.3 0 .6-.3.6-.6v-2.7c0-.3-.3-.6-.6-.6h-6.9V5c0-.4-.4-.6-.7-.6h-3.2c-.4 0-.7.3-.7.6v23.5c.2 7.3 3.2 12.1 11.9 13.5.4.1.8-.1.8-.5 0-3.6.1-4.1-.5-4.7m8.5-32.7c-2 0-3.5 1.6-3.5 3.6s1.6 3.6 3.5 3.6c2 0 3.5-1.6 3.5-3.6.1-2-1.5-3.6-3.5-3.6M29.1 29.2a12.2 12.2 0 0 0-12.3-12A12 12 0 0 0 4.6 29a12 12 0 0 0 11.8 12.2h.5a13 13 0 0 0 6.7-1.9v2.5l.1.1h5.2l.1-.1v-11l.1-1.6z"
                    />
                    <path
                      fill="#FFF"
                      d="M25.499999999999996 29.200000000000003l.1-.1h.2l-.1.1h-.2zm-.3 2.9l.1-.1-.1.1zm-.1.2l.1-.1-.1.1m-1.5 5.2l.1-.1-.1.1m-.5.2l.1-.1-.1.1m-6.9-1.5h.1l.1-.1-.2.1zm-8.6-4.8zm-.1.2v.1-.1m-.3-.7l.1.1-.1-.1M24.3 27.9l-.1-.1.1.1zm-.1.1l-.1.1.1-.1zm-1.6 3.3l-.1.1.1-.1zm-6.8-4.4zm11.7-.3v-.2h-.2v-.1h-.1l-.1-.3-.1-.3-.2-.1v.1h-.3l-.3.1v.7H26v.1l-.6.1-.5.1h-.1l-.1.1-.2.1v.1l-.1.1.1-.1V27l-.1.1h-.1l-.2.1H24l.1.1h-.4l-.4.2-.1.1-.1.5h.3v.3l-.1.1-.1.1-.1.1H23l.1-.1.1-.1.1-.1.1-.1h-.5l-.1.1h-.2l-.1.1v.1H22v-.2h.2V27.8l-.3.2h-.1l-.1.1v.1-.2l.1-.1v-.5h-.1l-.4-.2h-.4v.2-.1l-.1.1v.5l.1.1v.4l-.1.2-.1.1v.1l-.2.4-.1.1h-.1v-.1l-.1-.2v-.6l.1-.1v-.6l.1-.1v-.2l-.1.1v.2l-.1.1v-.2l.1-.2.1-.1h.1v.1l.1-.1h.2v-.1h.4V27H21v-.1h-.9l-.1-.1v-.1l-.1-.1h-.1v-.1l.1-.1h-.2l-.1.1-.1.1h-.1l-.1.1H19l-.1.1h-.2v-.2l-.2.1h-.2v-.1l.2-.2.3-.2h.1l.1-.1h-.7V26h-.5v-.1l-.1-.2v.2h-2.2l-.8-.7-.3-.1H14l-.3-.1-.3-.1-.3-.1-.3-.1h-.2l-.3-.1-.3-.1-.3-.1-.4-.1-.6-.2-.5-.1-.2-.1-.2-.1-.3-.1-.3-.1-.3-.1v.5l-.2.1h-.1V24l.1-.1v-.1h-.1l-.1-.1h-.3l-.1-.1v-.1V24.3v-.1.1l.1.1.1.1-.1-.1h-.1v.2l-.4.5-.1.1-.1.3v.1l-.1.1h-.1l-.1.1v.2l-.1.2v.4l-.1.1-.1.1-.1.4h-.1v1.1l.1.2V28.8v-.1h.1l.1.2h-.1v.1-.2.4H7v.2h-.1v.1l.1.2v.2l.1.1v.4l.1.1.1.3v.2l.1.1v.2h.1l.1.1v.1l.1.1v.5l.9.2 1.4 1 .8.2.3.1v-.2l.7.1.1.1v.1l.1.1v.2l.1.2.2.2.1.4.1.2.1.1.2.2.2.1.2-.3h.5l.1.1.1.1v.1l.1.1.1.4.1.2.1.2.1.1.1.4.1.2.1.1h.1l.1.1h.2l.2.1h.1V36.4h.1v-.1h.2v.1l.1-.1h.2l.1-.1v-.3.1h.1l.2-.1h.4l.2.1h.5l.1.1v.1h.1l.1.1h.6l.1-.1h.2l.1.1h.2v-.1l.5-.8h-.1v-.1l.1-.1v-.1h-.1V35h-.2l-.1-.1v-.1h.5l.1-.1h.4l.1-.2v.2h.2l.1-.1v.1h.5l.2.1v.1h.2l.1-.1h.3l.1.1v.1l.1.1h.2v.6-.1.4l.1.1.1.1v.1h.1l.1.2v.1h.2l.1-.1h.1v-1.2l-.1-.1v-.4l-.2-.2-.1-.3.4.5v-.4l.1-.2V34h.3l.2-.2v-.1h.1V33.4l.1-.1h.1l.1-.1v-.1l.1-.1.1-.1h.1l.1-.1V32.5h-.2v-.2.1h.1v.1-.6h-.2v-.1H24v-.3l.1-.1v-.1V31.6h.2v.5-.2l.1-.2v-.3l.7-1-.1-.2-.1-.2v-.1h.6v.1V29.1h.1l.1-.1h.3l.2-.1.1-.1v-.1.1h.1l.1-.1h.1l.1-.1v-.1.1h-.2v-.2h-.1v-.1l-.1-.1v-.1l.1-.1v-.7h.1v-.1h.1l.8-.4m0-.1"
                    />
                    <path
                      className="c-navbar__logo-type"
                      fill="currentColor"
                      d="M193.2 37.7v-1c0-1.9-1.1-3.5-3.2-3.5a3 3 0 0 0-3.3 2.7V43a3 3 0 0 0 2.9 3.2h.4c1.6.2 3-1 3.2-2.6v-1.9H191v1.6c0 .8-.3 1.3-1.1 1.3s-1.1-.5-1.1-1.4v-6.4c0-1 .3-1.4 1.1-1.4.5 0 1.1.5 1.1 1.6v1h2.2zm-7.8 8.3v-1.9h-3.3V33.4h-2.2V46h5.5zm-6.8 0v-1.9h-3.3V33.4H173V46h5.6zm-11.3-2.1h-2.1V46h.8l-.8 2.2h1l1.3-2.2v-2.1h-.2zm-3.2 2.1v-1.9h-3.3V33.4h-2.2V46h5.5zm-11.4-2.7h2.4l.3 2.9h2.1l-2.4-12.6h-2.7L150 46.1h2.1l.6-2.8zm1.1-7.3l1 5.4H153l.8-5.4zm-9.5 10v-8l2.7 8h1.9V33.4H147v7.2l-2.5-7.2h-2.1V46h1.9zm-8.4-9.4c0-1 .3-1.4 1.1-1.4s1.1.5 1.1 1.4V43c0 1-.3 1.4-1.1 1.4s-1.1-.5-1.1-1.4v-6.4zm-2.3 6.4a3.4 3.4 0 0 0 3.5 3.2 3.4 3.4 0 0 0 3.2-3.2v-6.5a3.4 3.4 0 0 0-3.5-3.2 3.4 3.4 0 0 0-3.2 3.2V43zm-2.4-9.6H129V46h2.2V33.4zM123.3 46h2.2V35.3h2.1v-1.9h-6.4v1.9h2.1V46zm-6.7-2.7h2.4l.3 2.9h2.1L119 33.6h-2.7L114.2 46h2.1l.3-2.7zm1.3-7.3l1 5.4h-1.7l.7-5.4zm-9.5 10v-8l2.7 7.9h1.9V33.4h-1.9v7.2l-2.5-7.2h-2.1V46h1.9zm-8.6-5.1h1.1l1.6 5.2h2.2l-1.7-5.7c.8-.3 1.4-1.1 1.4-3.2 0-2.7-1.3-3.7-3.7-3.7h-3v12.6h2.2v-5.2h-.1zm0-5.7h.8c1.1 0 1.6.5 1.6 1.9s-.5 1.9-1.6 1.9h-.8v-3.8zM96 46v-1.9h-3.8v-3.7h2.7v-1.9h-2.7v-3.2h3.7v-1.9h-5.7V46H96zm-11.5 0h2.2V35.3h2.1v-1.9h-6.4v1.9h2.1V46zm-7.9 0v-8l2.7 7.9h1.9V33.4h-1.9v7.2l-2.5-7.2h-2.2V46h2zm-4.5-12.6h-2.2V46h2.2V33.4zm102.1-16.2a3 3 0 0 0-3-3c-2.1 0-3.3 1.1-3.3 3.2 0 3.7 4.4 4.3 4.4 6.8 0 .8-.5 1.1-1.3 1.1-.6 0-1.3-.6-1.3-1.9l-2.1.3c.2 1.9 1.3 3.5 3.2 3.5 2.1 0 3.3-1.1 3.3-3.2 0-3.5-4.4-4.5-4.4-6.5 0-.8.3-1.3 1.1-1.3.5 0 1.1.3 1.1 1.4l2.3-.4zm-12.4 4.5h1.1l1.6 5.2h2.2l-1.7-5.7c.8-.3 1.6-1.1 1.6-3.2 0-2.7-1.3-3.7-3.7-3.7h-3v12.6h2.2v-5.2h-.3zm0-5.6h.8c1.1 0 1.6.5 1.6 1.9s-.5 1.9-1.6 1.9h-.8v-3.8zm-11 7.6c0 1.8 1.6 3.3 3.4 3.3 1.8 0 3.2-1.5 3.3-3.3v-9.4h-2.2v9.5c0 1-.3 1.4-1.1 1.4s-1.1-.5-1.1-1.4v-9.5h-2.2l-.1 9.4zm-6.5-6.3c0-1 .3-1.4 1.1-1.4s1.1.5 1.1 1.4v6.4c0 1-.3 1.4-1.1 1.4s-1.1-.5-1.1-1.4v-6.4zm-2.1 6.5a3.4 3.4 0 0 0 3.5 3.2 3.4 3.4 0 0 0 3.2-3.2v-6.5a3.4 3.4 0 0 0-3.5-3.2 3.4 3.4 0 0 0-3.2 3.2v6.5zm-5.6 3h2.2V16.1h2.1v-1.9h-6.4v1.9h2.1v10.8zm-7.9 0V19l2.7 7.9h1.9V14.3h-1.9v7.2l-2.5-7.2h-2.1v12.6h1.9zm-7.9-2.9h2.4l.3 2.9h2.1l-2.4-12.6h-2.5l-2.4 12.6h2.1l.4-2.9zm1.1-7.3l1 5.4h-1.7l.7-5.4zm-5 1.8v-.9c0-1.9-1.1-3.5-3.2-3.5a3 3 0 0 0-3.3 2.7v6.9a3 3 0 0 0 2.9 3.2h.4c1.6.2 3-1 3.2-2.6v-1.9h-2.2V24c0 .8-.3 1.3-1.1 1.3s-1.1-.5-1.1-1.4v-6.4c0-1 .3-1.4 1.1-1.4.5 0 1.1.5 1.1 1.6v1l2.2-.2zm-8.9-4.2h-2.2v12.6h2.2V14.3zm-9 7.4h1.1l1.6 5.2h2.2l-1.7-5.7c.8-.3 1.4-1.1 1.4-3.2 0-2.7-1.3-3.7-3.7-3.7h-3v12.6h2.2v-5.2H99zm0-5.6h.8c1.1 0 1.6.5 1.6 1.9s-.5 1.9-1.6 1.9H99v-3.8zm-3.8 10.8V25h-3.8v-3.7h2.7v-1.9h-2.7v-3.2H95v-1.9h-5.7v12.6h5.9zM84.4 14.3l-1.6 7.3-1.6-7.3h-2.9v12.6h1.9V17l1.9 9.9h1.1l1.9-9.9v9.9h2.1V14.3h-2.8zm-12 9.7h2.4l.3 2.9h2.1l-2.4-12.6h-2.7l-2.4 12.6h2.1l.6-2.9zm1.3-7.3l1 5.4H73l.7-5.4z"
                    />
                  </svg>
                </Link>
                <ul
                  className={cn('c-navbar__nav', { 'is-open': on })}
                  onClick={setOff}
                >
                  <li>
                    <Link
                      to="/who-we-are/our-advantage"
                      className="c-nav-link t-link"
                      activeClassName="active"
                    >
                      WHO WE ARE
                  </Link>
                    <ul
                      className={cn('c-navbar__subnav', {
                        visible: location.pathname.indexOf('who-we-are') >= 0,
                      })}
                    >
                      <li>
                        <Link
                          to="/who-we-are/our-advantage"
                          className="c-nav-link c-nav-link--sub t-subnav-link"
                          activeClassName="active"
                        >
                          Our Advantage
                      </Link>
                      </li>
                      <li>
                        <Link
                          to="/who-we-are/our-mission"
                          className="c-nav-link c-nav-link--sub t-subnav-link"
                          activeClassName="active"
                        >
                          Our Mission
                      </Link>
                      </li>
                      <li>
                        <Link
                          to="/who-we-are/why-ati"
                          className="c-nav-link c-nav-link--sub t-subnav-link"
                          activeClassName="active"
                        >
                          Why ATI
                      </Link>
                      </li>
                      <li>
                        <Link
                          to="/who-we-are/whats-new"
                          className="c-nav-link c-nav-link--sub t-subnav-link"
                          activeClassName="active"
                        >
                          What's New
                      </Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link
                      to="/what-we-offer/hotels-and-lodging"
                      className="c-nav-link t-link"
                      activeClassName="active"
                    >
                      WHAT WE OFFER
                  </Link>
                    <ul
                      className={cn('c-navbar__subnav', {
                        visible: location.pathname.indexOf('what-we-offer') >= 0,
                      })}
                    >
                      <li>
                        <Link
                          to="/what-we-offer/hotels-and-lodging"
                          className="c-nav-link c-nav-link--sub t-subnav-link"
                          activeClassName="active"
                        >
                          Hotels & Lodging
                      </Link>
                      </li>
                      <li>
                        <Link
                          to="/what-we-offer/escorted-tours"
                          className="c-nav-link c-nav-link--sub t-subnav-link"
                          activeClassName="active"
                        >
                          Escorted Tours
                      </Link>
                      </li>
                      <li>
                        <Link
                          to="/what-we-offer/airtours"
                          className="c-nav-link c-nav-link--sub t-subnav-link"
                          activeClassName="active"
                        >
                          Air Tours
                      </Link>
                      </li>
                      <li>
                        <Link
                          to="/what-we-offer/drive-america"
                          className="c-nav-link c-nav-link--sub t-subnav-link"
                          activeClassName="active"
                        >
                          DriveAmerica™
                      </Link>
                      </li>
                      <li>
                        <Link
                          to="/what-we-offer/attractions-and-transportation"
                          className="c-nav-link c-nav-link--sub t-subnav-link"
                          activeClassName="active"
                        >
                          Attractions & Transportation
                      </Link>
                      </li>
                      <li>
                        <Link
                          to="/what-we-offer/group-travel"
                          className="c-nav-link c-nav-link--sub t-subnav-link"
                          activeClassName="active"
                        >
                          Group Travel
                      </Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link
                      to="/our-technology"
                      className="c-nav-link t-link"
                      activeClassName="active"
                    >
                      OUR TECHNOLOGY
                  </Link>
                  </li>
                  <li>
                    <Link
                      to="/careers"
                      className="c-nav-link t-link"
                      activeClassName="active"
                    >
                      CAREERS
                  </Link>
                  </li>
                  <li>
                    <Link
                      to="/contact"
                      className="c-nav-link t-link"
                      activeClassName="active"
                    >
                      CONTACT
                  </Link>
                  </li>
                </ul>
                {this.renderLogin()}
              </nav>
            )}
          </Toggle>
        )
      }}
    />
  }
}

export default Navbar



// WEBPACK FOOTER //
// ./src/components/Navbar.js